import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordJetpackView } from '../services/jetpackStats';

// Renders nothing. Fires a Jetpack page view on the initial load and on every
// client-side route change, so SPA navigation is counted the way the old
// multi-page WordPress site was.
function JetpackStats() {
  const location = useLocation();

  useEffect(() => {
    recordJetpackView();
  }, [location.pathname, location.search]);

  return null;
}

export default JetpackStats;
